import React from "react";

import CookieConsent from "react-cookie-consent";
import Mainwrapper from "src/components/Mainwrapper.js";
import distances from "src/assets/styles/distances.js";

import colors from "src/assets/styles/colors.js";
import Markdown from "markdown-to-jsx";
import slugify from "slugify";
import noHangers from "src/assets/fn/noHangers.js";

const MyA = ({ children, ...props }) => <a {...props}>{children}</a>;

const Cookies = ({ yes, no, text, pageName, lang }) => {
  const privacyLink = `${lang == "pl" ? "/" : `/${lang}/`}${slugify(pageName, {
    lower: true,
    strict: true,
  })}`;

  return (
    <CookieConsent
      style={{
        background: `${colors.white}`,
        padding: " 10rem",
        color: `${colors.dark}`,
        margin: `10rem ${distances.pageMarginBig}rem 20rem`,
        width: `calc(100% - ${distances.pageMarginBig * 2}rem - 20rem)`,
        borderRadius: "8rem",
        filter: "drop-shadow(0px -1.425px 71.25px rgba(0, 0, 0, 0.08))",

        alignItems: "center",
      }}
      buttonStyle={{
        background: `${colors.dark}`,
        margin: "5rem 10rem 5rem 15rem",
        fontSize: "15rem",
        border: "solid 1rem #231f1f",
        fontSize: "15rem",
        borderRadius: "50rem",
        lineHeight: "30rem",
        color: `${colors.white}`,
        padding: "0rem 25rem",
      }}
      declineButtonStyle={{
        background: `transparent`,
        margin: "5rem 15rem 5rem 5rem",
        color: `${colors.darkGrey}`,
        border: "solid 1rem #231f1f",
        fontSize: "15rem",
        lineHeight: "30rem",
        borderRadius: "50rem",
        padding: "0rem 25rem",
      }}
      location="bottom"
      buttonText={yes}
      enableDeclineButton
      flipButtons
      declineButtonText={no}
      cookieName="gatsby-gdpr-google-tagmanager"
    >
      <span
        className="cookieText"
        style={{ fontSize: "12rem", width: "70%", display: "inline-block" }}
      >
        {" "}
        <Markdown
          className={"markdownP"}
          options={{
            overrides: {
              a: {
                component: MyA,
                props: {
                  href: `${privacyLink}`,
                },
              },
            },
          }}
        >
          {noHangers(text)}
        </Markdown>
      </span>
    </CookieConsent>
  );
};
export default Cookies;
